// extracted by extract-css-chunks-webpack-plugin
module.exports = {"date":"sent-summary__date___3f6Ny","number":"sent-summary__number___13vtx","split-panel":"sent-summary__split-panel___3ppW_","splitPanel":"sent-summary__split-panel___3ppW_","sub-panel":"sent-summary__sub-panel___uPFnf","subPanel":"sent-summary__sub-panel___uPFnf"};
    if(module.hot) {
      // 1765151222207
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  